import styled from 'styled-components';
import type { ReactNode } from 'react';

const Main = styled.main`
  width: min(1440px, 100%);
  margin: 0 auto;
  padding: calc(72px + env(safe-area-inset-top) + 1rem) 1.25rem 2rem;
`;

export default function FunnelShell({ children }: { children: ReactNode }) {
  return <Main>{children}</Main>;
}
